<template>
  <div class="navbar">
    <dinapsis-navbar
      applicationname="Suite"
      :menu.prop="menu"
      :helpPanelConfig.prop="helpPanel"
      :keycloak.prop="KeycloakInstance()"
      @click-menu="menuClicked($event)"
    ></dinapsis-navbar>
  </div>
</template>
<script>
import * as AuthService from '@/services/AuthService.js';
import * as RolService from '@/services/RolService.js';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isSuperAdmin: 'PF/isSuperAdmin',
      isAdmin: 'PF/isAdmin',
      isAdminEntidad: 'PF/isAdminEntidad',
      isExternal: 'PF/isExternal',
      haveEntidadesVisiblesRelated: 'PF/haveEntidadesVisiblesRelated',
      isDeliveryUser: 'PF/isDeliveryUser'
    })
  },
  async created () {
    this.$eventHub.$on(RolService.externalUsersAccessRefreshEvent, this.refreshExternalUsersAccess);
    await this._getMenu();
    this.selectedItemMenu();
  },
  mounted () {
    this.observeMenuIsOpen();
  },
  beforeDestroy () {
    this.$eventHub.$off(RolService.externalUsersAccessRefreshEvent, this.refreshExternalUsersAccess);
    if (this.observer) this.observer.disconnect();
  },
  data () {
    return {
      menu: [],
      isOpen: false,
      helpPanel: {
        width: '25dvw',
        groups: [
          {
            name: this.$t('helpPanel.title'),
            color: '#5587C8',
            items: [
              {
                iconLeft: 'description',
                text: this.$t('helpPanel.groups.manual'),
                url: 'https://sites.google.com/aquatec.es/suite',
                iconRight: 'open_in_new',
                target: '_blank'
              },
              {
                iconLeft: 'public',
                text: this.$t('helpPanel.groups.support'),
                url: 'https://smartwater.atlassian.net/servicedesk/customer/portal/216',
                iconRight: 'open_in_new',
                target: '_blank'
              },
              {
                iconLeft: 'group',
                text: this.$t('helpPanel.groups.userCommunity'),
                url: 'https://chat.google.com/room/AAQAAmxs6mM?cls=1',
                iconRight: 'open_in_new',
                target: '_blank'
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    KeycloakInstance () {
      return AuthService.KeycloakInstance();
    },
    async refreshExternalUsersAccess () {
      await this._getMenu();
      this.selectedItemMenu();
    },
    observeMenuIsOpen () {
      const targetNode = document.getElementById('main');

      if (targetNode) {
        this.observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const currentlyOpened = targetNode.classList.contains('dx-drawer-opened');

              if (currentlyOpened !== this.isOpen) {
                this.isOpen = currentlyOpened;
              }
            }
          }
        });

        const config = { attributes: true, attributeFilter: ['class'] };
        this.observer.observe(targetNode, config);
      }
    },
    async _getMenu () {
      await RolService.getEntidadesVisiblesRelated();
      const shouldHideExternalUsers = await RolService.shouldHideExternalUsers();

      if (this.isSuperAdmin) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'servicios',
            text: this.$t('navbar.digital_services'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'ambitos',
            text: this.$t('navbar.scopes'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'tematicas',
            text: this.$t('navbar.themes'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'verticales',
            text: this.$t('navbar.verticals'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: this.$t('navbar.entities'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: this.$t('navbar.export'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdmin && !this.isAdminEntidad && !this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: this.$t('navbar.export'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
        if (this.haveEntidadesVisiblesRelated) {
          const auth = {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          };
          this.menu.splice(3, 0, auth);
        }
      } else if (this.isAdmin && !this.isAdminEntidad && this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: this.$t('navbar.export'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdmin && this.isAdminEntidad) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: this.$t('navbar.entities'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: this.$t('navbar.export'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdminEntidad && !this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: this.$t('navbar.entities'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdminEntidad && this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: this.$t('navbar.entities'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: this.$t('navbar.aplications'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: this.$t('navbar.users'),
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (!this.isExternal || this.isExternal) {
        this.menu = [
          {
            id: 'catalogo',
            text: this.$t('navbar.portfolio'),
            icon: 'inbox',
            selected: false,
            children: []
          }
        ];
        if (this.haveEntidadesVisiblesRelated) {
          const auth = {
            id: 'autorizaciones',
            text: this.$t('navbar.authorizations'),
            icon: 'send',
            selected: false,
            children: []
          };
          this.menu.push(auth);
        }
      }

      const misServiciosDigitales = {
        id: 'serviciosDigitales',
        text: this.$t('navbar.my_digital_services'),
        icon: 'send',
        selected: false,
        children: []
      };
      if (this.isSuperAdmin || this.haveEntidadesVisiblesRelated) {
        this.menu.splice(1, 0, misServiciosDigitales);
      }

      if (shouldHideExternalUsers) this.removeMenuItem('usuarios');
    },
    removeMenuItem (id) {
      this.menu = this.menu.filter(item => item.id !== id);
    },
    menuClicked (e) {
      // Same route?
      if (this.$route.name === e.detail) return;
      // Check if exist route with this name
      if (!this.checkIfExistRoute(e.detail)) return;

      this.$router.push({ name: e.detail });
    },
    checkIfExistRoute (routeName) {
      const routeExist = this.$router.options.routes.some(route => {
        return route.name === routeName || (route.children && route.children.some(child => child.name === routeName));
      });

      if (!routeExist) {
        this.$router.push({ name: '404' });
        return false;
      }

      return true;
    },
    selectedItemMenu () {
      // Find item name inside menu to select by default
      const { name } = this.$route;
      if (!name) return;

      const item = this.searchRouteIntoMenu(name, this.menu);
      if (!item) return;

      // Select item
      item.selected = true;
    },

    searchRouteIntoMenu (nameToFind, menu) {
      for (let itemMenu of menu) {
        if (nameToFind === itemMenu.id) return itemMenu;
        if (itemMenu.children && itemMenu.children.length > 0) {
          return this.searchRouteIntoMenu(nameToFind, menu);
        }
      }
    }
  },
  watch: {
    isOpen: {
      handler: function () {
        // Set mutation
        this.$store.commit('PF/refreshToggleMenu', this.isOpen);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar {
  &:deep() {
    .user-menu-closed {
      .user-name {
        height: 0;
      }
      .menu-user-btn {
        vertical-align: middle;
        position: relative;
      }
    }
  }
}
</style>
